import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
// antd
import { Avatar, Image, Row, Select, Spin } from 'antd'

// slices
import {
    projectsList,
    projectsState,
    changePage as changeProjectPage,
} from '../projects/projects.slice'
import { changePage, teamListGet, teamState } from '../team/team.slice'
import { loginState } from '../login/login.slice'
import {
    dateRangesList,
    filterChangeReports,
    projectReportsState,
} from './projectReports/projectReports.slice'

// constants
import { WORKSPACE_ADMIN, SUPER_ADMIN } from '../../constants/roles'

// filter
import DateFilter from './dateFilter'
import { CrossIcon } from '../../assets/icons'

const ProjectWiseFilter = ({ name }) => {
    const { Option } = Select

    const dispatch = useDispatch()

    const { pageLimit, currentPage, skipPage, isNext, projects, status } =
        useSelector(projectsState)

    const { filter } = useSelector(projectReportsState)
    const {
        teamList,
        teamListLoading,
        skipPage: teamSkipPage,
        currentPage: teamCurrentPage,
        pageLimit: teamPageLimit,
        isNext: teamIsNext,
    } = useSelector(teamState)
    const { userProfile } = useSelector(loginState)

    const initialState = {
        filteredAssignees: [],
        optionLoading: false,
        filteredProjects: [],
        projectOptionLoading: false,
        selectAssignees: [],
        selectProjects: [],
    }

    const [state, setState] = useState(initialState)
    const [searchValue, setSearchValue] = useState('');

    // USER DATA SET WITH FILTER
    useEffect(() => {
        if (teamList && Array.isArray(teamList)) {
            const filterUsers = teamList.map((data) => {
                return {
                    label: data?.name,
                    value: data?._id,
                    profilePicture: data?.profilePicture,
                }
            })
            setState((prevState) => ({
                ...prevState,
                filteredAssignees: filterUsers,
            }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teamList])

    // PROJECT DATA SET WITH FILTER
    useEffect(() => {
        if (projects && Array.isArray(projects)) {
            let filterProjects = []

            const projectsList = Array.isArray(projects) && projects?.map((data) => {
                return {
                    label: data?.name,
                    value: data?._id,
                    projectProfile: data?.projectProfile,
                }
            })
            filterProjects = [...projectsList]

            setState((prevState) => ({
                ...prevState,
                filteredProjects: filterProjects,
            }))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects])

    // ON SCROLL TEAM MEMBER LIST
    const onScrollTeam = async (e) => {
        let scroll =
            Math.ceil(e.target.offsetHeight + e.target.scrollTop) >=
            e.target.scrollHeight
        if (scroll) {
            if (teamIsNext) {
                setState((prevState) => ({ ...prevState, optionLoading: true }))
                dispatch(
                    teamListGet({
                        skip: teamSkipPage + teamPageLimit,
                        limit: teamPageLimit,
                        projectId: filter?.projectId,
                    })
                )
                dispatch(
                    changePage({
                        currentPage: teamCurrentPage + 1,
                        skip: teamSkipPage + teamPageLimit,
                        pageLimit: teamPageLimit,
                    })
                )
                setState((prevState) => ({
                    ...prevState,
                    optionLoading: false,
                }))
            }
        }
    }

    // ON SCROLL TEAM MEMBER LIST
    const onScrollProject = async (e) => {
        let scroll =
            Math.ceil(e.target.offsetHeight + e.target.scrollTop) >=
            e.target.scrollHeight
        if (scroll) {
            if (isNext) {
                setState((prevState) => ({
                    ...prevState,
                    projectOptionLoading: true,
                }))
                dispatch(
                    projectsList({
                        skip: skipPage + pageLimit,
                        limit: pageLimit,
                    })
                )
                dispatch(
                    changeProjectPage({
                        currentPage: currentPage + 1,
                        skip: skipPage + pageLimit,
                        pageLimit: pageLimit,
                    })
                )
                setState((prevState) => ({
                    ...prevState,
                    projectOptionLoading: false,
                }))
            }
        }
    }

    const debouncedFetchProject = useCallback(
        debounce((value) => {
            dispatch(
                projectsList({
                    // skip: skipPage + pageLimit,
                    // limit: pageLimit,
                    search: value
                })
            )
        }, 600),
        []
    );
    const debouncedFetchUser = useCallback(
        debounce((value, projectId) => {
            dispatch(
                teamListGet({
                    skip: 0,
                    limit: teamPageLimit,
                    search: value,
                    projectId: projectId,
                })
            )
        }, 600),
        []
    );
    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;

        const selectedUser = state.filteredAssignees.find(user => user.value === value);

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#f5f5f5',
                    borderRadius: 10,
                    padding: '4px 8px 4px 4px',
                    margin: '4px 2px',
                    maxWidth: '100%',
                    border: '1px solid #afafaf80',
                }}
            >
                {selectedUser?.profilePicture ? (
                    <Avatar
                        size={25}
                        src={selectedUser.profilePicture}
                        style={{ marginRight: 6 }}
                    />
                ) : (
                    <Avatar
                        size={25}
                        style={{
                            backgroundColor: 'rgb(0 10 129 / 25%)',
                            color: '#000',
                            fontSize: 10,
                            marginRight: 6,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {selectedUser?.label?.[0]?.toUpperCase()}
                        {selectedUser?.label?.split(' ')[1]?.[0]?.toUpperCase()}
                    </Avatar>
                )}
                <span
                    style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#333',
                        marginRight: 4,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: 100,
                    }}
                >
                    {selectedUser?.label}
                </span>
                {closable && (
                    <span
                        onClick={onClose}
                        style={{ cursor: 'pointer', display: 'flex' }}
                    >
                        <CrossIcon width={10} color={'#252525'} />
                    </span>
                )}
            </div>
        );
    }

    return (
        <Row
            align={'middle'}
            justify={'space-between'}
            style={{
                width: '100%',
                flexFlow: 'row nowrap',
            }}
        >
            <Row
                align={'middle'}
                style={{
                    columnGap: '20px',
                    width: '100%',
                    flexFlow: 'row nowrap',
                }}
            >


                <Select
                    showSearch
                    size='large'
                    onSearch={(value) => {
                        setSearchValue(value); // track input
                        debouncedFetchProject(value);
                    }}
                    onDropdownVisibleChange={(open) => {
                        if (open) {
                            debouncedFetchProject('');
                        } else {
                            setSearchValue('');
                        }
                    }}
                    placeholder="Select a Project"
                    onChange={(value) => {
                        setState((prevState) => ({
                            ...prevState,
                            selectProjects: value,
                            filteredAssignees: [],
                        }))
                        dispatch(
                            filterChangeReports({
                                ...filter,
                                projectId: value,
                                assigneeId: [],
                            })
                        )
                    }}
                    filterOption={false}
                    notFoundContent={
                        status === "loading" ? (
                            <Spin size="small" />
                        ) : state?.filteredProjects?.length === 0 ? (
                            'No projects found'
                        ) : null
                    }
                    style={{
                        width: '100%',
                        height: "auto"
                    }}
                    maxTagCount={1}
                    value={filter?.projectId}
                // rootClassName="p-0-multiSelect"
                // rootClassName={['projectReportsSelect projectSearchInput']}
                >
                    {state?.filteredProjects?.map((data) => (
                        <Option value={data?.value} key={data?.label}>
                            <Row align="middle" style={{ columnGap: '10px' }}>
                                <Image
                                    src={data?.projectProfile}
                                    width={22}
                                    height={22}
                                    style={{
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        minWidth: '22px',
                                        display: "flex"
                                    }}
                                    preview={false}
                                />
                                {data?.label}
                            </Row>
                        </Option>
                    ))}
                </Select>

                {/* Remove the condition for the role check
                 to show the assignee filter for all users */}

                {/* (userProfile?.role?.roleName === WORKSPACE_ADMIN ||
                    userProfile?.role?.roleName === SUPER_ADMIN)  */}
                {/* {state?.filteredAssignees?.length > 0 && ( */}
                <Select
                    showSearch
                    size='small'
                    placeholder="Select a User"
                    className='reports_user_selecter'
                    onSearch={(value) => {
                        // setSearchValue(value);
                        debouncedFetchUser(value, filter?.projectId);
                    }}
                    // className="add_member_model"
                    filterOption={false}
                    onChange={(value) => {
                        setState((prevState) => ({
                            ...prevState,
                            selectAssignees:
                                typeof value === 'object' ? value : [value],
                        }))
                        dispatch(
                            filterChangeReports({
                                ...filter,
                                assigneeId:
                                    typeof value === 'object'
                                        ? value
                                        : [value],
                            })
                        )
                    }}
                    value={
                        name === 'screenShots'
                            ? filter?.assigneeId[0]
                            : filter?.assigneeId
                    }
                    tagRender={tagRender}

                    // onPopupScroll={onScrollTeam}
                    style={{
                        width: '100%',
                        borderRadius: "8px"
                    }}
                    // styles={{ root: { borderRadius: "8px" } }}
                    notFoundContent={
                        teamListLoading ? (
                            <Spin size="small" />
                        ) : state?.filteredAssignees?.length == 0 ? (
                            'No User found'
                        ) : null
                    }
                    mode={name !== 'screenShots' && 'multiple'}
                    getPopupContainer={() => document.body}
                    // maxTagCount={1}
                    rootClassName="p-0-multiSelect"

                >
                    {state?.filteredAssignees?.length > 0 &&
                        state?.filteredAssignees.map((data) => {
                            return (
                                <Option
                                    value={data?.value}
                                    key={data?.label}
                                >
                                    <Row
                                        align={'middle'}
                                        style={{
                                            columnGap: '10px',
                                        }}
                                    >
                                        {data?.profilePicture ? (
                                            <>
                                                <Image
                                                    src={
                                                        data?.profilePicture
                                                    }
                                                    width={25}
                                                    height={25}
                                                    style={{
                                                        borderRadius: '50%',
                                                        minWidth: '25px',
                                                        objectFit: 'cover',
                                                    }}
                                                    preview={false}
                                                />
                                            </>
                                        ) : (
                                            <Avatar
                                                style={{
                                                    backgroundColor:
                                                        'rgb(0 10 129 / 25%)',
                                                    height: '25px',
                                                    width: '25px',
                                                    minWidth: '25px',
                                                    display: 'flex',
                                                    justifyContent:
                                                        'center',
                                                    alignItems: 'center',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {data?.label[0].toUpperCase()}
                                                {data?.label.split(
                                                    ' '
                                                )[1] !== undefined &&
                                                    data?.label.split(
                                                        ' '
                                                    )[1] !== '' &&
                                                    data?.label
                                                        .split(' ')[1][0]
                                                        .toUpperCase()}
                                            </Avatar>
                                        )}
                                        {data?.label}
                                    </Row>
                                </Option>
                            )
                        })}
                </Select>
                {/* )} */}
            </Row>
            <DateFilter
                props={{
                    dateRangesList: dateRangesList,
                    name: name,
                    selectedProject: state.selectProjects,
                    selectAssignees: state.selectAssignees
                }}
            />
        </Row>
    )
}

export default ProjectWiseFilter
